import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import Dashboard from '../components/Dashboard';

export default function HomePage() {
  return (
    <>
      <Helmet>
        <meta name="keywords" content="calculator, online calculator, free calculator, math calculator, financial calculator, scientific calculator, calculator suite, web calculator, calculator tools, calculato, calculation tools, BMI calculator, mortgage calculator, investment calculator" />
      </Helmet>
      <Suspense fallback={<div>Loading...</div>}>
        <Dashboard />
      </Suspense>
    </>
  );
}
